import styled from 'styled-components'

const UserInfo = styled.div`
  margin: 0 2rem;
  .user {
    font-size: 3rem;
    text-align: center;
    margin: 1.5rem 0;
  }
  .email {
    text-align: center;
    margin: 1.5rem 0;
    font-size: 2rem;
  }
  .balance,
  .selling {
    font-size: 2rem;
  }
`

export default UserInfo